import { RelatorioPortariaPdfResponse } from "features/portaria/typings";
import { PDFRelatorioBase } from "components/PDF";
import useRelatorioPortariaPdfColumns from "../../hooks/useRelatorioPortariaPdfColumns";

function PDFRelatorioPortaria(props: RelatorioPortariaPdfResponse) {
  const columns = useRelatorioPortariaPdfColumns({
    includePessoaAcao: props.items.some((item) => !!item.pessoaAcao),
  });

  return (
    <PDFRelatorioBase
      title="Relatório de portarias confirmadas"
      relatorioData={props}
      columns={columns}
      includeMinHeight={true}
    />
  );
}

export default PDFRelatorioPortaria;
